<template>
    <tr :draggable="item.type === 1" @drag="dragItem(item)">
        <td>
            <div class="content-element" :class="{ 'selected': item.selected }">
                <div v-for="i in deep" class="spacer"></div>
                <template v-if="item.type === 2">
                    <div v-if="item.openned !== true" class="content-element__opener" @click.stop="openDir(item)">
                        <svg data-name="opener" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-name="opener" d="M1 1.75L7 7L1 12.25" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="content-element_icons" v-else-if="item.openned == true && checkHasFiles(item)">
                        <div class="content-element__opener is-open" @click.stop="closeDir(item)">
                            <svg data-name="opener" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path data-name="opener" d="M1 1.75L7 7L1 12.25" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <input class="content-element__checkbox" type="checkbox" :checked="areAllFilesSelected(item)" @change="toggleSelect(item, $event)">
                    </div>
                    <div class="content-element_icons" v-else>
                        <div class="content-element__opener is-open" @click.stop="closeDir(item)">
                            <svg data-name="opener" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path data-name="opener" d="M1 1.75L7 7L1 12.25" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </template>
                <div v-if="item.type === 2" class="content-element__file">
                    <svg width="17" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.402 2.767h-7.18L5.876.544A.164.164 0 005.766.5H.682a.636.636 0 00-.64.634v11.732c0 .35.286.634.64.634h14.72c.355 0 .64-.283.64-.634V3.4a.636.636 0 00-.64-.634z" fill="currentColor" />
                    </svg>
                    <span>{{item.title}}</span>
                </div>
                <div v-if="item.type === 1" class="content-element__file">
                    <input class="content-element__checkbox" type="checkbox" :checked="item.selected" @change="toggleSelect(item, $event)">
                    <svg v-if="item.type_id === 2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.25 0.777778V1.55556H10.5V0.777778C10.5 0.35 10.1062 0 9.625 0H4.375C3.89375 0 3.5 0.35 3.5 0.777778V1.55556H1.75V0.777778C1.75 0.35 1.35625 0 0.875 0C0.39375 0 0 0.35 0 0.777778V13.2222C0 13.65 0.39375 14 0.875 14C1.35625 14 1.75 13.65 1.75 13.2222V12.4444H3.5V13.2222C3.5 13.65 3.89375 14 4.375 14H9.625C10.1062 14 10.5 13.65 10.5 13.2222V12.4444H12.25V13.2222C12.25 13.65 12.6438 14 13.125 14C13.6062 14 14 13.65 14 13.2222V0.777778C14 0.35 13.6062 0 13.125 0C12.6438 0 12.25 0.35 12.25 0.777778ZM3.5 10.8889H1.75V9.33333H3.5V10.8889ZM3.5 7.77778H1.75V6.22222H3.5V7.77778ZM3.5 4.66667H1.75V3.11111H3.5V4.66667ZM12.25 10.8889H10.5V9.33333H12.25V10.8889ZM12.25 7.77778H10.5V6.22222H12.25V7.77778ZM12.25 4.66667H10.5V3.11111H12.25V4.66667Z" fill="currentColor" />
                    </svg>
                    <svg v-else width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 2.85714C0 2.09938 0.302901 1.37266 0.842068 0.836838C1.38124 0.30102 2.1125 0 2.875 0H20.125C20.8875 0 21.6188 0.30102 22.1579 0.836838C22.6971 1.37266 23 2.09938 23 2.85714V17.1429C23 17.9006 22.6971 18.6273 22.1579 19.1632C21.6188 19.699 20.8875 20 20.125 20H2.875C2.1125 20 1.38124 19.699 0.842068 19.1632C0.302901 18.6273 0 17.9006 0 17.1429V2.85714ZM1.4375 15.7143V17.1429C1.4375 17.5217 1.58895 17.8851 1.85853 18.153C2.12812 18.4209 2.49375 18.5714 2.875 18.5714H20.125C20.5062 18.5714 20.8719 18.4209 21.1415 18.153C21.411 17.8851 21.5625 17.5217 21.5625 17.1429V12.1429L16.1331 9.36143C15.9983 9.29432 15.8456 9.27104 15.6968 9.29488C15.5479 9.31872 15.4104 9.38848 15.3036 9.49429L9.9705 14.7943L6.14675 12.2629C6.00869 12.1715 5.8431 12.1304 5.67804 12.1466C5.51298 12.1627 5.35862 12.2351 5.24275 12.3507L1.4375 15.7143ZM1.4375 13.7057L4.94643 10.5336C5.34886 10.1829 5.87114 10.0612 6.37675 10.2043C6.88236 10.3473 7.29004 10.7329 7.49375 11.2557C7.62398 11.6027 7.87417 11.8904 8.20221 12.0683C8.53024 12.2463 8.91167 12.3018 9.27725 12.2236C9.64282 12.1453 9.96676 11.9405 10.1946 11.6471L15.5171 6.41929C15.9393 5.94326 16.5653 5.66427 17.2261 5.64097C17.8869 5.61767 18.5294 5.85247 19.0069 6.28929L21.5625 8.56643V2.85714C21.5625 2.47829 21.411 2.11488 21.1415 1.84702C20.8719 1.57916 20.5062 1.42857 20.125 1.42857H2.875C2.49375 1.42857 2.12812 1.57916 1.85853 1.84702C1.58895 2.11488 1.4375 2.47829 1.4375 2.85714V13.7057ZM6.625 6.42857C6.625 5.86025 6.39782 5.31521 5.99345 4.91334C5.58907 4.51148 5.04062 4.28571 4.46875 4.28571C3.89688 4.28571 3.34843 4.51148 2.94405 4.91334C2.53968 5.31521 2.3125 5.86025 2.3125 6.42857C2.3125 6.99689 2.53968 7.54194 2.94405 7.9438C3.34843 8.34566 3.89688 8.57143 4.46875 8.57143C5.04062 8.57143 5.58907 8.34566 5.99345 7.9438C6.39782 7.54194 6.625 6.99689 6.625 6.42857ZM8.625 6.42857C8.625 5.86025 8.39782 5.31521 7.99345 4.91334C7.58907 4.51148 7.04062 4.28571 6.46875 4.28571C5.89688 4.28571 5.34843 4.51148 4.94405 4.91334C4.53968 5.31521 4.3125 5.86025 4.3125 6.42857C4.3125 6.99689 4.53968 7.54194 4.94405 7.9438C5.34843 8.34566 5.89688 8.57143 6.46875 8.57143C7.04062 8.57143 7.58907 8.34566 7.99345 7.9438C8.39782 7.54194 8.625 6.99689 8.625 6.42857Z" fill="currentColor" />
                    </svg>
                    <span>{{item.name}}</span>
                </div>
            </div>
        </td>
        <td v-if="item.type === 2">
            -
        </td>
        <td v-if="item.type === 1">
            {{item.duration}}
        </td>
    </tr>
    <nautilus-row-element
        v-if="item.openned === true"
        v-for="row in item.content"
        @openDir="openDir"
        :item="row"
        :deep="deep + 1"
        @dragItem="dragItem"
        @toggleSelect="pushItem"
        :hasFiles="hasFiles"
        >
    </nautilus-row-element>
</template>

<script>
export default {
    name: "NautilusRowElement",
    props: {
        item: Object,
        deep: Number,
        hasFiles: Boolean
    },
    emits: [
        'openDir',
        'dragItem',
        'toggleSelect',
        'closeDir'
    ],
    methods: {
        openDir: async function (item) {
            let result = await this.$emit('openDir', item);
            item.openned = true;
        },
        closeDir: function (item) {
            item.openned = false;
        },
        dragItem: function (item) {
            this.$emit('dragItem', item);
        },
        toggleSelect: function (item, event) {
            event.stopPropagation();
            if (item.type === 2) {
                const isSelected = event.target.checked;
                this.selectNestedItems(item, isSelected);
            } else {
                item.selected = !item.selected;
                this.$emit('toggleSelect', item);
            }
        },
        selectNestedItems(item, isSelected) {
            if (item.content && Array.isArray(item.content)) {
                item.content.forEach(subItem => {
                    if (subItem.type === 1) {
                        subItem.selected = isSelected;
                        this.$emit('toggleSelect', subItem);
                    }
                });
            }
        },
        areAllFilesSelected(item) {
            if (item.content && Array.isArray(item.content)) {
                return item.content.every(subItem => subItem.type === 1 && subItem.selected);
            }
            return false;
        },
        pushItem: function (item) {
            if (item.type !== 2) {
                this.$emit('toggleSelect', item);
            }
        },
        checkHasFiles: function (item) {
            return item.content && item.content.some(child => child.type === 1);
        }
    }
}
</script>

<style scoped>
    .content-element.selected {
        color: #0678F4;
    }
    .content-element__checkbox {
        margin: 0px 10px 0px 10px;
    }
    .content-element_icons {
        display: flex;
    }
</style>
